module.exports = __webpack_public_path__ + "static/media/GoldRush.e24dc1ff.jpg";